/** AP06 copy (one group per control; a ticket edits only its own file). */
export const ap06PtBr = {
  title: 'Baixa de estimativa e estorno devido',
  description:
    'Estimativa substituída pela conta definitiva sem duplicar a despesa; estornos devidos conferidos.',
  prerequisite: '',
  reasons: {
    DOUBLE_EXPENSE_one: '{{count}} despesa em duplicidade',
    DOUBLE_EXPENSE_other: '{{count}} despesas em duplicidade',
    OVERDUE_AUTO_REVERSAL_one: '{{count}} estorno automático pendente',
    OVERDUE_AUTO_REVERSAL_other: '{{count}} estornos automáticos pendentes',
  },
  observations: {
    trueUp_one:
      '{{count}} estimativa com valor real diferente (ajuste já lançado no período da nota)',
    trueUp_other:
      '{{count}} estimativas com valor real diferente (ajuste já lançado no período da nota)',
    restrictedOverdue_one:
      '{{count}} estorno automático pendente em conta restrita (não exibido aqui)',
    restrictedOverdue_other:
      '{{count}} estornos automáticos pendentes em contas restritas (não exibidos aqui)',
    over: 'Realizado maior que a estimativa',
    under: 'Realizado menor que a estimativa',
    estimate: 'Estimado:',
    actual: 'Realizado:',
    accrual: 'Provisão',
    bill: 'Conta',
    journal: 'Lançamento',
  },
  truncated: 'Mostrando as primeiras 100 pendências desta avaliação.',
};

export const ap06En: typeof ap06PtBr = {
  title: 'Estimate settlement and due reversals',
  description:
    'Estimate replaced by the definitive bill without double expense; due reversals checked.',
  prerequisite: '',
  reasons: {
    DOUBLE_EXPENSE_one: '{{count}} duplicate expense',
    DOUBLE_EXPENSE_other: '{{count}} duplicate expenses',
    OVERDUE_AUTO_REVERSAL_one: '{{count}} overdue auto-reversal',
    OVERDUE_AUTO_REVERSAL_other: '{{count}} overdue auto-reversals',
  },
  observations: {
    trueUp_one:
      '{{count}} estimate with a different actual value (already trued up in its own period)',
    trueUp_other:
      '{{count}} estimates with a different actual value (already trued up in their own period)',
    restrictedOverdue_one:
      '{{count}} overdue auto-reversal on a restricted account (not shown here)',
    restrictedOverdue_other:
      '{{count}} overdue auto-reversals on restricted accounts (not shown here)',
    over: 'Actual higher than estimate',
    under: 'Actual lower than estimate',
    estimate: 'Estimated:',
    actual: 'Actual:',
    accrual: 'Accrual',
    bill: 'Bill',
    journal: 'Journal',
  },
  truncated: 'Showing the first 100 findings of this evaluation.',
};
